/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-08-25 10:00:55 */

const Keys = {
  priceOverview: 'priceOverview',
  travelDate: 'travelDate',
  numberParticipants: 'numberParticipants',
  tourOperator: 'tourOperator',
  tourOperatorTT: 'tourOperatorTT',
  tourOperatorTTAG: 'tourOperatorTTAG',
  duration: 'duration',
  groupSize: 'groupSize',
  flights: 'flights',
  yourBusStop: 'yourBusStop',
  day: 'day',
  day_plural: 'day_plural',
  hotel: 'hotel',
  trip: 'trip',
  isNormalGroup: 'isNormalGroup',
  isSmallGroup: 'isSmallGroup',
  isMiniGroup: 'isMiniGroup'
}; export default Keys;